import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { API } from "../../api/apiIndex";

const ContactUs = () => {
  const captchaRef = useRef(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [message, setMessage] = useState("");
  const [messageError, setMessageError] = useState("");

  const [formSubmitting, setFormSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("submitted");

    let err = false;
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

    if (!captchaVerified) {
      err = true;
    }
    if (!name) {
      setNameError("Name is required");
      err = true;
    }
    if (!email) {
      setEmailError("Email is required");
      err = true;
    } else if (!emailRegex.test(email)) {
      setEmailError("Not a valid email");
      err = true;
    }
    if (!message) {
      setMessageError("Message is required");
      err = true;
    }

    if (!err) {
      const data = { name, email, message };
      // console.log(data);
      setFormSubmitting(true);
      await API.post("/contact/create", data);
      setFormSubmitting(false);
      // console.log(res);
      setName("");
      setEmail("");
      setMessage("");
      captchaRef.current.reset();
      setCaptchaVerified(false);
    }
  };

  const onCaptchaChange = (e) => {
    setCaptchaVerified(true);
  };

  return (
    <section
      id="contactus"
      className="flex flex-col sm:px-16 px-0 justify-center items-center sm:pb-[145px] pb-12"
    >
      <span className="mb-[12px] uppercase text-[18px] tracking-[3px] leading-8 text-secondary">
        Contact us
      </span>
      <h1 className="mb-[20px] font-bold sm:text-[40px] text-[32px] leading-[44px] text-secondary">
        Get In Touch
      </h1>
      <p className="mb-[48px] text-textSecondary text-[20px] leading-8 max-w-[470px] px-4 text-center">
        Have any suggesstions or recommendation. Feel free to leave a message.
      </p>
      <form
        onSubmit={handleSubmit}
        className="bg-white sm:px-[130px] sm:py-[80px] p-6 flex flex-col gap-5 justify-center items-center rounded-md border-gray-400 border shadow-md"
      >
        <div className="flex sm:w-[370px] w-[270px] flex-col gap-3">
          <label htmlFor="name" className="text-[#131B42] font-bold">
            NAME
          </label>
          <input
            type="text"
            name="name"
            id="name"
            className="h-12 border rounded-md border-[#DADADA] pl-3 text-textSecondary"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setNameError("");
            }}
          />
          <span className="pl-4 text-[12px] italic text-red-500">
            {nameError}
          </span>
        </div>
        <div className="flex sm:w-[370px] w-[270px] flex-col gap-3">
          <label htmlFor="email" className="text-[#131B42] font-bold">
            EMAIL
          </label>
          <input
            type="email"
            name="email"
            id="email"
            className="h-12 border rounded-md border-[#DADADA] pl-3 text-textSecondary"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError("");
            }}
          />
          <span className="pl-4 text-[12px] italic text-red-500">
            {emailError}
          </span>
        </div>
        <div className="flex sm:w-[370px] w-[270px] flex-col gap-3">
          <label htmlFor="message" className="text-[#131B42] font-bold">
            MESSAGE
          </label>
          <textarea
            id="message"
            name="message"
            rows="5"
            className="border rounded-md border-[#DADADA] pl-3 pt-3 text-textSecondary"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setMessageError("");
            }}
          ></textarea>
          <span className="pl-4 text-[12px] italic text-red-500">
            {messageError}
          </span>
        </div>

        <ReCAPTCHA
          ref={captchaRef}
          sitekey="6Lfp1uoiAAAAADHdbPopCBi03cgJsLeNCZYaYclQ"
          onChange={onCaptchaChange}
        />

        <button
          className="bg-secondary text-white font-bold rounded-md border-secondary border-2 h-[48px] w-[170px] disabled:bg-gray-300 disabled:border-gray-300 disabled:text-gray-600"
          disabled={!captchaVerified || formSubmitting}
        >
          {formSubmitting ? <span>....</span> : <span>SUBMIT</span>}
        </button>
      </form>
    </section>
  );
};

export default ContactUs;
